import React from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import classNames from "classnames"
import Layout from "../../../components/Layout/Layout"
import SEO from "../../../components/seo"
import componentStyles from "./video-sift.module.scss"
import VideoSiftResult1 from "../../../assets/images/projects/video-shift/video-sift-result-1.png"

import SecondTitle from "../../../components/UI/SecondTitle/SecondTitle"

const firstListItems = [
	"projects.video-sift.solution-description.list.first-text",
	"projects.video-sift.solution-description.list.second-text",
	"projects.video-sift.solution-description.list.third-text",
]

const technologyBackgroundItems = [
	{
		titlePath:
			"projects.video-sift.technology-background.list.first-item.title",
		textPath: "projects.video-sift.technology-background.list.first-item.text",
	},
	{
		titlePath:
			"projects.video-sift.technology-background.list.second-item.title",
		textPath: "projects.video-sift.technology-background.list.second-item.text",
	},
	{
		titlePath:
			"projects.video-sift.technology-background.list.third-item.title",
		textPath: "projects.video-sift.technology-background.list.third-item.text",
	},
	{
		titlePath:
			"projects.video-sift.technology-background.list.forth-item.title",
		textPath: "projects.video-sift.technology-background.list.forth-item.text",
	},
	{
		titlePath:
			"projects.video-sift.technology-background.list.fifth-item.title",
		textPath: "projects.video-sift.technology-background.list.fifth-item.text",
	},
]

const resultsItems = [
	"projects.video-sift.results.list.first-text",
	"projects.video-sift.results.list.second-text",
	"projects.video-sift.results.list.third-text",
	"projects.video-sift.results.list.forth-text",
	"projects.video-sift.results.list.fifth-text",
]

const VideoSift: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	const challengeClasses = classNames(
		componentStyles.challenge,
		"container"
	)
	const challengeTitleClasses = classNames(
		componentStyles.challengeTitle,
		"large-section-title",
		"section-title-h2"
	)
	const solutionDescriptionClasses = classNames(
		componentStyles.solutionDescription,
		"container"
	)
	const solutionDescriptionTitleClasses = classNames(
		componentStyles.solutionDescriptionTitle,
		"large-section-title",
		"section-title-h2"
	)
	const numberedListClasses = classNames(
		componentStyles.solutionDescriptionNumberedList,
		"grid-3"
	)

	const technologyBackgroundClasses = classNames(
		componentStyles.technologyBackground,
		"container"
	)
	const technologyBackgroundTitleClasses = classNames(
		componentStyles.technologyBackgroundTitle,
		"large-section-title",
		"section-title-h2"
	)
	const technologyBackgroundTextClasses = classNames(
		componentStyles.technologyBackgroundText
	)
	const tilesListClasses = classNames(
		componentStyles.technologyBackgroundTilesList,
		"grid-3"
	)

	const resultsClasses = classNames(componentStyles.results, "container")
	const resultsTitleClasses = classNames(
		componentStyles.resultsTitle,
		"large-section-title",
		"section-title-h2"
	)
	const resultsCubeListClasses = classNames(
		componentStyles.resultsCubeList,
		"grid-2"
	)
	const pathname = location.pathname
	const projectUrl = pathname.split("/")[3]

	return (
		<Layout location={location}>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "projects-new.list.video.description" })}
				title={intl.formatMessage({ id: "projects-new.list.video.metatitle" })}
				pathname={location.pathname}
			/>
			<SecondTitle desktopImage="/images/projects/video-shift/banner.png" mobileImage="/images/projects/video-shift/banner-m.jpg" titleColor="dark" title={intl.formatMessage({
				id: "projects.video-sift.banner.title"
			})} position="right center" back="dark" />
			<section className="container">
				<div className={componentStyles.clientCompany}>
					<h2 className="large-section-title section-title-h2">
						{intl.formatMessage({
							id: "projects.video-sift.banner.client-company",
						})}
					</h2>
					<div className={componentStyles.sectionText}>
						{intl.formatMessage({
							id: "projects.video-sift.banner.client-name",
						})}
					</div>
				</div>
			</section>
			<section className={challengeClasses}>
				<div className={componentStyles.challengeTextBlock}>
					<h2 className={challengeTitleClasses}>
						{intl.formatMessage({
							id: "projects.video-sift.challenge.title",
						})}
					</h2>
					<p className={componentStyles.challengeText}>
						{intl.formatMessage({
							id: "projects.video-sift.challenge.paragraph-1",
						})}
					</p>
					<p className={componentStyles.challengeText}>
						{intl.formatMessage({
							id: "projects.video-sift.challenge.paragraph-2",
						})}
					</p>
				</div>
			</section>
			<section className={solutionDescriptionClasses}>
				<div className={componentStyles.solutionDescriptionTextBlock}>
					<h2 className={solutionDescriptionTitleClasses}>
						{intl.formatMessage({
							id: "projects.video-sift.solution-description.title",
						})}
					</h2>
					<p className={componentStyles.solutionDescriptionText}>
						{intl.formatMessage({
							id: "projects.video-sift.solution-description.paragraph-1",
						})}
					</p>
					<p className={componentStyles.solutionDescriptionText}>
						{intl.formatMessage({
							id: "projects.video-sift.solution-description.paragraph-2",
						})}
					</p>
				</div>
				<ol className={numberedListClasses}>
					{firstListItems.map(translatePath => (
						<li
							key={translatePath}
							className={componentStyles.solutionDescriptionNumberedListItem}
						>
							<p
								className={
									componentStyles.solutionDescriptionNumberedListItemText
								}
							>
								{intl.formatMessage({
									id: translatePath,
								})}
							</p>
						</li>
					))}
				</ol>
			</section>
			<section className={technologyBackgroundClasses}>
				<h2 className={technologyBackgroundTitleClasses}>
					{intl.formatMessage({
						id: "projects.video-sift.technology-background.title",
					})}
				</h2>
				<p className={technologyBackgroundTextClasses}>
					{intl.formatMessage({
						id: "projects.video-sift.technology-background.text",
					})}
				</p>
				<ul className={tilesListClasses}>
					{technologyBackgroundItems.map(({ titlePath, textPath }) => (
						<li
							key={titlePath}
							className={componentStyles.technologyBackgroundTilesItem}
						>
							<h4 className={componentStyles.technologyBackgroundTilesTitle}>
								{intl.formatMessage({
									id: titlePath,
								})}
							</h4>
							{intl.formatMessage({
								id: textPath,
							})}
						</li>
					))}
				</ul>
			</section>
			<section className={resultsClasses}>
				<h2 className={resultsTitleClasses}>
					{intl.formatMessage({
						id: "projects.video-sift.results.title",
					})}
				</h2>
				<p className={componentStyles.resultsText}>
					{intl.formatMessage({
						id: "projects.video-sift.results.text",
					})}
				</p>
				<div className="grid-3">
					<ul className={resultsCubeListClasses}>
						{resultsItems.map(textPath => (
							<li key={textPath} className={componentStyles.resultsCubeItem}>
								{intl.formatMessage({
									id: textPath,
								})}
							</li>
						))}
					</ul>
					<img
						src={VideoSiftResult1}
						className={componentStyles.resultsImage}
						alt={intl.formatMessage({
							id: "projects.video-sift.results.first-image-alt",
						})}
						width="368"
						height="300"
					/>
				</div>
			</section>
		</Layout>
	)
}
export default VideoSift
